export const MOBILE_APP_LINK = {
  app_store: "https://apps.apple.com/us/app/amarpet/id6463717709",
  play_store: "https://play.google.com/store/apps/details?id=com.amarpet.app",
};

export const MOBILE_APP_ONE_LINK = "https://onelink.to/2mpyxc";
